import { useParams } from "react-router-dom";
import { useGetSurveyQuestionById } from "../../api/survey";
import { Center, Loader, Text } from "@mantine/core";
import QuestionForm from "./QuestionForm";
import { useContext } from "react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useGetEvent } from "../../api/event";
import { useUpdateSurveyQuestion } from "../../api/survey";

function EditQuestion() {
  const { user } = useContext(AuthContext);
  const workspace = getCurrentWorkspace(user);
  const { data: event, isPending: eventPending } = useGetEvent(
    workspace.eventId
  );

  const { id: surveyId, questionId } = useParams();
  const {
    data: question,
    isPending: questionPending,
    isError: questionError,
    error,
  } = useGetSurveyQuestionById(surveyId, questionId);

  const updateQuestion = useUpdateSurveyQuestion({ surveyId, questionId });

  const handleSubmit = (payload, { reset, data }) => {
    updateQuestion.mutate(payload, {
      onSuccess: () => {
        reset(data);
      },
    });
  };

  if (eventPending || questionPending)
    return (
      <Center>
        <Loader />
      </Center>
    );

  if (questionError) return <Text c="red">{error.message}</Text>;

  return (
    <QuestionForm
      event={event}
      question={question}
      type="edit"
      onSubmit={handleSubmit}
    />
  );
}

export default EditQuestion;
